import { Empty } from 'antd';
import React, { memo } from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { WarehouseIcon } from 'components/common/icons';
import { Col, EditableInfoComponent } from 'components';
import { WarehouseCard } from 'feature/countryTabs/warehouses/WarehouseCard';
import { useWarehouses } from 'feature/countryTabs/warehouses/useWarehouses';
import { AddEditWarehouseModal } from './addEdit';
import { WarehouseType } from '../index';

import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const CountryWarehouses = memo(() => {
  const { hasAccess } = useAccessControl();
  const { onWarehouseEdit, onWarehouseModalStateChange, warehouseToEdit, isWarehouseModalOpen, data } = useWarehouses();

  return (
    <Col span={12}>
      <EditableInfoComponent
        title={'Warehouses'}
        icon={<WarehouseIcon color={'#308D82'} />}
        creatable={hasAccess(PERMISSIONS.countries.warehouse.write)}
        editable={false}
        onAdd={onWarehouseModalStateChange}
      />
      {data?.map((i: WarehouseType) => <WarehouseCard onEdit={() => onWarehouseEdit(i)} key={i.id} data={i} />)}
      {(!data || !data?.length) && <Empty style={{ marginTop: 50 }} />}
      <AddEditWarehouseModal
        dataToEdit={warehouseToEdit}
        openModal={isWarehouseModalOpen}
        onModalStateChange={onWarehouseModalStateChange}
      />
    </Col>
  );
});
